export type ILogger = Pick<typeof console, 'debug' | 'error' | 'info' | 'log' | 'warn'> & {
    monitor?: {
        reportValue?: (attrId: string, value: number, dimensions?: string[]) => void;
        reportStatus?: (attrId: string, status: number, errMsg?: string, dimensions?: string[]) => void;
    };
    aegis?: {
        report?: (...msg: any) => void;
    };
    tdw?: (data: any) => void;
    tdrec?: (arg0: any, arg1: any) => void;
    getPrototype?: () => {
        report: (type: string, params: { query: { startTs: number; endTs: number } }) => { value: string };
    };
};

/** 监控指标 STATUS */
export enum MonitorStatus {
    SUCCESS = 0,
    ERROR = 1,
    TIMEOUT = 2,
}
